<template>
  <div class="template-container">
    <div class="template-content">
      <div class="header-main">
        <div class="header-content">
          <span class="left-main">HW-25V</span>
          <div class="right-main">
            <router-link to="/hw25v"
                         class="main-item">{{$t('industry_zt25v.text1')}}</router-link>
            <router-link to="/zt25v-data"
                         class="main-item active-item">{{$t('industry_zt25v.text2')}}</router-link>
          </div>
        </div>
      </div>
      <div class="body-main">
        <div class="main-content">
          <div class="content-header">HW-25V {{$t('industry_zt25v.text2')}}</div>
          <div class="content-body">
            <div class="item-main">
              <h4 class="item-title">{{ $t('industry_zt25v.text26')}}</h4>
              <div class="item-content">
                <div class="item-param"
                     v-for="(item, index) in $t('industry_zt25v.list')"
                     :key="index">
                  <div class="param-title">{{ item.title }}</div>
                  <div class="param-desc">{{ item.desc }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZT25v",
  data () {
    return {
      list: [
        {
          title: "飞行器材质",
          desc: "航空复合材料"
        },
        {
          title: "起降方式",
          desc: "垂直起降"
        },
        {
          title: "巡航速度",
          desc: "70-110km/h"
        },
        {
          title: "续航时间",
          desc: "240min"
        },
        {
          title: "有效作业半径",
          desc: "50/100km"
        },
        {
          title: "有效载荷",
          desc: "10kg"
        },
        {
          title: "定位精度",
          desc: "水平1cm、垂直2cm"
        },
        {
          title: "抗风能力",
          desc: "7级"
        },
        {
          title: "外形尺寸",
          desc: "4130mm×1930mm×750mm"
        },
        {
          title: "运输箱尺寸",
          desc: "1560mm×630mm×817mm"
        }
      ]
    };
  }
};
</script>

<style lang="stylus" scoped>
.template-container {
  .template-content {
    background: #000;
    min-width: 1280px;
    margin: 0 auto;

    .header-main {
      height: 66px;
      border-bottom: 1px solid #333;

      .header-content {
        max-width: 1280px;
        margin: 0 auto;
        position: relative;

        .left-main {
          padding-left: 48px;
          line-height: 66px;
          font-size: 14px;
          color: #fff;
        }

        .right-main {
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;

          .main-item {
            padding: 0 48px;
            line-height: 66px;
            color: #666;
            font-size: 14px;
            cursor: pointer;
          }

          .active-item {
            color: #fff;
          }
        }
      }
    }

    .body-main {
      width: 1280px;
      height: 820px;
      margin: 0 auto;

      .main-content {
        .content-header {
          height: 97px;
          line-height: 97px;
          text-align: center;
          border-bottom: 1px solid #333333;
          font-size: 26px;
          font-weight: 400;
          color: #FFFFFF;
        }

        .content-body {
          .item-main {
            padding: 60px 0;

            .item-title {
              font-size: 26px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 37px;
              padding-bottom: 60px;
            }

            .item-content {
              display: flex;
              flex-wrap: wrap;

              .item-param {
                width: 420px;
                margin-bottom: 60px;
                padding-left: 60px;
                box-sizing: border-box;

                .param-title {
                  font-size: 16px;
                  font-weight: 400;
                  color: #FFFFFF;
                  line-height: 22px;
                  padding-bottom: 10px;
                }

                .param-desc {
                  font-size: 16px;
                  font-weight: 400;
                  color: #999999;
                  line-height: 22px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media all and (max-width: 768px) {
  .template-container {
    .template-content {
      min-width: 100%;

      .header-main {
        .header-content {
          max-width: 100%;

          .right-main {
            right: 36px;

            .main-item {
              padding: 0 12px;
            }
          }
        }
      }

      .body-main {
        width: 100%;
        height: auto;

        .main-content {
          .content-header {
            height: 97px;
            line-height: 97px;
            text-align: center;
            border-bottom: 1px solid #333333;
            font-size: 26px;
            font-weight: 400;
            color: #FFFFFF;
          }

          .content-body {
            padding: 0 20px;

            .item-main {
              padding: 60px 0;

              .item-title {
                font-size: 26px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 37px;
                padding-bottom: 60px;
              }

              .item-content {
                display: flex;
                flex-wrap: wrap;

                .item-param {
                  width: 50%;
                  margin-bottom: 60px;
                  padding-left: 0;
                  text-align: center;
                  box-sizing: border-box;

                  .param-title {
                    font-size: 16px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 22px;
                    padding-bottom: 10px;
                  }

                  .param-desc {
                    width: calc(100% - 20px);
                    margin: 0 auto;
                    font-size: 16px;
                    font-weight: 400;
                    color: #999999;
                    line-height: 22px;
                    word-break: break-all;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry/zt25vData.vue